module.exports = __webpack_public_path__ + "img/201910121615358787621a7c45732ef5e14c9204fc6160.e871a9e5.jpg";